module.exports = __webpack_public_path__ + "static/media/icon-help.6ea57158.svg";